export const PullQuote = ({ quote }) => {
  return (
    <div className="w-full p-10 bg-primary md:px-36 xl:p-24 xl:px-48">
      <p className="text-2xl font-semibold text-white leading-extra-loose md:px-20 xl:text-4xl ">
        {quote}
      </p>
    </div>
  )
}
